import useSWR from 'swr';
import { Customer } from '../types';
import { apiClient } from '../services/apiClient';

interface UseCustomerReturn {
  customer: Customer | null;
  loading: boolean;
  error: Error | undefined;
}

const customerFetcher = async (customerId: string): Promise<Customer | null> => {
  return (await apiClient.getCustomerById(customerId)) ?? null;
};

export const useCustomer = (customerId: string | undefined): UseCustomerReturn => {
  const { data, error, isLoading } = useSWR<Customer | null, Error>(
    customerId ? `/api/v1/customers/${customerId}` : null,
    () => customerFetcher(customerId!),
    {
      revalidateOnFocus: false,
      revalidateOnReconnect: true,
      dedupingInterval: 5000,
    }
  );

  return {
    customer: data ?? null,
    loading: isLoading,
    error,
  };
};
